var map = {
	"./Logo-1.svg": "2393",
	"./Logo-10.svg": "e2ea",
	"./Logo-11.svg": "a4e2",
	"./Logo-12.svg": "2be2",
	"./Logo-13.svg": "5306",
	"./Logo-14.svg": "243a",
	"./Logo-15.svg": "66fe",
	"./Logo-16.svg": "efe3",
	"./Logo-17.svg": "8480",
	"./Logo-18.svg": "559b",
	"./Logo-19.svg": "dbcb",
	"./Logo-2.svg": "c527",
	"./Logo-20.svg": "eb22",
	"./Logo-21.svg": "62f8",
	"./Logo-22.svg": "a367",
	"./Logo-23.svg": "23ac",
	"./Logo-24.svg": "5579",
	"./Logo-25.svg": "ce6c",
	"./Logo-26.svg": "edb1",
	"./Logo-27.svg": "2f51",
	"./Logo-28.svg": "a7c9",
	"./Logo-29.svg": "ce9e",
	"./Logo-3.svg": "cf1eb",
	"./Logo-30.svg": "9131",
	"./Logo-4.svg": "da4c",
	"./Logo-5.svg": "cf517",
	"./Logo-6.svg": "1e01f",
	"./Logo-7.svg": "8d28",
	"./Logo-8.svg": "6198",
	"./Logo-9.svg": "f28b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "68a1";